import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-search-field',
    templateUrl: './search-field.component.html',
    styleUrls: ['./search-field.component.scss'],
    standalone: false
})
export class SearchFieldComponent implements OnInit {
  searchText: UntypedFormControl;
  @Input() formGroup: UntypedFormGroup;
  @Input() placeholder: string;

  constructor() {
    this.searchText = new UntypedFormControl('');
   }

  ngOnInit() {
    this.formGroup.addControl('searchText', this.searchText);
  }
}
